// extracted by mini-css-extract-plugin
export var footer = "_mz-0";
export var inherit = "_mz-1";
export var input = "_mz-2";
export var modalContent = "_mz-3";
export var quillEditor = "_mz-4";
export var subtitle = "_mz-5";